module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal d-modal--full-width text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeFilters.apply(null, arguments)
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Gennemsnits undervisningstal")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoading) ? _c('Loader') : [_c('div', {
    staticClass: "avg-uv__toolbar"
  }, [_c('div', {
    staticClass: "avg-uv__filters",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Grupper',
      "tags": _vm.uniqueGroups,
      "selectedTags": _vm.selectedGroups,
      "closeFromProp": _vm.closeFiltersCount,
      "numberOfSelectedTagsToShow": 4,
      "placeholder": 'Alle grupper'
    },
    on: {
      "select": _vm.toggleGroup,
      "clear": _vm.clearGroups
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.asyncLoadXLSXAndDownload.apply(null, arguments)
      }
    }
  }, [_vm._v("\n            Download til Excel\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "avg-uv__table-scroll"
  }, [_c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    staticClass: "avg-uv__narrow"
  }, [_vm._v("Ansættelsesgrad")]), _vm._v(" "), _c('th', {
    staticClass: "avg-uv__narrow"
  }, [_vm._v("Timeansættelse pr. uge")]), _vm._v(" "), _c('th', {
    staticClass: "avg-uv__narrow"
  }, [_vm._v("Uv-timer")]), _vm._v(" "), _c('th', {
    staticClass: "avg-uv__narrow"
  }, [_vm._v("Normeret til fuldtid")])])]), _vm._v(" "), _c('tbody', [(_vm.filteredRows.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('i', [_vm._v("Ingen personer matcher filtrene")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredRows), function(row) {
    return _c('tr', {
      key: row.userId
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('td', {
      staticClass: "avg-uv__narrow"
    }, [_vm._v(_vm._s(_vm.formatPercentage(row.employmentPercentage)))]), _vm._v(" "), _c('td', {
      staticClass: "avg-uv__narrow"
    }, [_vm._v(_vm._s(row.weeklyHours === null ? '' : _vm.formatDecimal(row.weeklyHours)))]), _vm._v(" "), _c('td', {
      staticClass: "avg-uv__narrow"
    }, [_vm._v(_vm._s(_vm.formatDecimal(row.teachingHours)))]), _vm._v(" "), _c('td', {
      staticClass: "avg-uv__narrow"
    }, [_vm._v(_vm._s(row.normalizedToFullTime === null ? '' : _vm.formatDecimal(row.normalizedToFullTime)))])])
  })], 2), _vm._v(" "), (_vm.filteredRows.length > 0) ? _c('tfoot', [_c('tr', {
    staticClass: "avg-uv__summary"
  }, [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Gennemsnit (normeret) — " + _vm._s(_vm.summary.count) + " medarbejdere")])]), _vm._v(" "), _c('td', {
    staticClass: "avg-uv__narrow"
  }, [_c('strong', [_vm._v(_vm._s(_vm.summary.average === null ? '' : _vm.formatDecimal(_vm.summary.average)))])])])]) : _vm._e()])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Luk")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c4cf6db2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AvgTeachingHoursModal.vue
// module id = 2119
// module chunks = 1